<template>
	<div
		class="column-wrapper dropzone"
		:class="[node.class, getClass(node)]"
		:data-key="node.key"
		:id="node.id"
		:style="getColStyle(node)"
	>
		<NodeTree
			v-for="(child, i) in childrens"
			:node="child"
			:key="i"
			:onPreview="onPreview"
			:previewDevice.sync="previewDevice"
			:settings="settings"
		/>
		<!-- empty -->
		<div
			class="column-empty-view"
			v-if="childrens.length <= 0" v-tooltip="'Drag Element Here'"
			@click="onChangePanel">
			<div class="column-empty-view__first-add">
				<i class="material-icons d-block">add</i>
			</div>
		</div>

	</div>

	<!-- <div
		:class="[
			node.class,
			'col-element',
		]"
		:id="`column-${node.id}`"
		:style="getColStyle(node)"
	>
		<NodeAction :node="node" component="col" v-if="!onPreview" />

		<div
			class="column-gap dropzone"
			:id="node.id"
			:data-key="node.key">

			<NodeTree
				v-for="(child, i) in childrens"
				:node="child"
				:key="i"
				:onPreview="onPreview"
				:previewDevice.sync="previewDevice"
			/>

			<div
				class="column-empty-view"
				v-if="childrens.length <= 0" v-tooltip="'Drag Element Here'"
				@click="onChangePanel">
				<div class="column-empty-view__first-add">
					<i class="material-icons d-block">add</i>
				</div>
			</div>

		</div>
	</div> -->
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
// import NodeAction from '@/components/funnels/pagebuilder/nodes/NodeAction.vue';

export default {
	name: 'NodeCol',
	props: ['node', 'onPreview', 'previewDevice', 'settings'],
	components: {
		// NodeAction,
	},
	data() {
		return {
			isLoading: false,
			// previewDevice: 'desktop',
		};
	},
	computed: {
		...mapGetters({
			draggedElement: 'funnels/draggedElement',
			activeDropArea: 'funnels/activeDropArea',
		}),

		childrens() {
			return this.node?.children ?? [];
		},
	},
	updated() {},
	methods: {
		...mapActions({
			setDropArea: 'funnels/setDropArea',
		}),
		getColStyle({ options }) {
			const device = this.previewDevice;
			const style = {};

			if (options) {
				// const { width } = options;
				let width = false;
				if (device === 'desktop' && options.width) {
					width = options.width;
					style['flex-basis'] = 'auto';
					style['max-width'] = 'none';
					style['flex-grow'] = 'inherit';
				} else if (device === 'mobile' && options.mobile_width) {
					width = options.mobile_width;
					style['flex-basis'] = 'auto';
					style['max-width'] = 'none';
					style['flex-grow'] = 'inherit';
				} else if (device === 'mobile' && !options.mobile_width) {
					width = 100;
				}

				style.width = `${width}%`;
			}


			return style;
		},
		getClass(node) {
			let verticalAlignClass = '';
			if (node.options && node.options.verticalAlign) {
				verticalAlignClass += `align-vertical align-vertical--${node.options.verticalAlign}`;
			}

			return verticalAlignClass;
		},
		onChangePanel() {
			this.$bus.$emit('change-panel-status', 'elements');
		},
		initResizeable() {
			const options = {
				handles: 'e',
				distance: 10,
				// eslint-disable-next-line
				resize: (e, ui) => {
					e.preventDefault();
					const size = ui.size.width;
					console.log('size: ', size);
				},
			};
			const id = `#column-${this.node.id}`;
			if (id) {
				$(document)
					.find(id)
					.resizable(options);

				$(document)
					.find('.ui-resizable-e')
					.css('cursor', 'col-resize');
			}
		},
		jqueryIntegration() {
			// init resizeable
			this.initResizeable();
		},
	},
};
</script>

<style lang="scss">
.ui-resizable-handle {
	position: absolute;
	font-size: 0.1px;
	display: block;
	-ms-touch-action: none;
	touch-action: none;
	/* cursor: col-resize; */
}

.ui-resizable-s {
	cursor: s-resize;
	height: 7px;
	width: 100%;
	bottom: -5px;
	left: 0;
}

.ui-resizable-e {
	cursor: e-resize;
	width: 7px;
	right: -5px;
	top: 0;
	height: 100%;
}


</style>
